export const emailRegex = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

export const mobileRegex = /^\d{10}$/;

export const regexThatTargetsAllUppercaseInString = /(?=[A-Z])/;
